/* v0.0.5 Lab Heartbeat teaser: first tap on touch opens NOTA, second tap goes;
 * a red flash plays before leaving. Without this file the logo is a plain link. */
(function () {
  var el = document.querySelector('.lab-tease');
  if (!el) return;
  var text = el.querySelector('.lab-tease__pill-text');
  var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var coarse = window.matchMedia('(hover: none)').matches;

  function setOpen(open) {
    el.classList.toggle('is-open', open);
    if (text) text.textContent = open ? el.dataset.openLabel : el.dataset.label;
  }

  el.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') setOpen(true); });
  el.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') setOpen(false); });
  el.addEventListener('focus', function () { setOpen(true); });
  el.addEventListener('blur', function () { setOpen(false); });

  el.addEventListener('click', function (e) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    if (coarse && !el.classList.contains('is-open')) {
      e.preventDefault();
      setOpen(true);
      return;
    }
    if (still) return;
    e.preventDefault();
    var r = el.getBoundingClientRect();
    var flash = document.createElement('div');
    flash.className = 'lab-tease-flash';
    flash.style.setProperty('--x', r.left + r.width / 2 + 'px');
    flash.style.setProperty('--y', r.top + r.height / 2 + 'px');
    document.body.appendChild(flash);
    setTimeout(function () { window.location.href = el.href; }, 620);
  });

  // Tap elsewhere closes it again on touch.
  document.addEventListener('click', function (e) {
    if (coarse && !el.contains(e.target)) setOpen(false);
  });

  // Coming back with the browser Back button: clear the flash.
  window.addEventListener('pageshow', function () {
    var f = document.querySelector('.lab-tease-flash');
    if (f) f.remove();
    setOpen(false);
  });
})();
